module.exports = __webpack_public_path__ + "static/john-ocean-veggies.25556dc1.jpg";